'use client';
import { CardItemEntity } from '@entities/desktop/cards';
import { ProductsQuery } from '@hooks/queries/common.types';
import { useProducts } from '@hooks/queries/use-query-products';
import { ListCardsWidget } from '@widgets/desktop';
import React, { useRef } from 'react';
import { useMediaQuery } from 'usehooks-ts';

import { SeeAllButton } from '@/shared/components/see-all-button';
import { Label } from '@/shared/ui';

export const RECOMMENDED_ITEMS_QUERY_KEY = 'recommended-products' as const;

export const getRecommendedQueryFilters = (pageParam: number) => {
  const query: ProductsQuery = {
    filter: {
      search: '',
      types: [
        {
          type: 'pet',
        },
        {
          type: 'egg',
        },
        {
          type: 'potion',
        },
        {
          type: 'transport',
        },
      ],
      onlyHotSales: false,
      onlyNew: false,
      onlyExclusive: false,
      onlyDiscount: false,
    },
    order: {
      by: 'relevance',
      direction: 'desc',
    },
    page: 0,
    limit: 16,
  };

  return query;
};

export const RecommendedItems = () => {
  const loadMoreRef = useRef<HTMLDivElement>(null);
  const { isLoading, items, isFetching } = useProducts({
    getQueryFiltersFn: getRecommendedQueryFilters,
    uniqueQueryKey: RECOMMENDED_ITEMS_QUERY_KEY,
  });

  const isLargeScreen = useMediaQuery('(min-width: 1920px)');
  const isMediumScreen = useMediaQuery('(min-width: 1440px)');
  const isSmallScreen = useMediaQuery('(min-width: 1024px)');

  const slicesItems = isLargeScreen
    ? items
    : isMediumScreen
      ? items.slice(0, 14)
      : items.slice(0, 12);

  return (
    <ListCardsWidget
      cardsVariant={'primary'}
      topSlot={
        <>
          <Label labelVariant={'yellow'} icon={'graph-up'} variant={'primary'}>
            Recommended Items
          </Label>{' '}
          <SeeAllButton href={'/shop?sort=relevance'} />
        </>
      }
      isLoading={isFetching}
      bottomSlot={
        <>
          {slicesItems.map((item, index) => (
            <CardItemEntity
              propertiesSorting={'relevance'}
              applyHandleClickOnFullCard
              isMM2Variant={false}
              variant={'primary'}
              key={`card-${index}-${item.realName}-${item?.name}`}
              item={item}
            />
          ))}
          {!isFetching && <div ref={loadMoreRef}></div>}
        </>
      }
    />
  );
};
